<template>
  <div class="content">
    <div class="container-fluid">
      <card>
        <h4 class="mt-0">Yazı Ekle</h4>
        <b-alert show variant="danger" dismissible v-if="errors.length">
          <h4 class="alert-heading my-0 text-center">
            <i class="fas fa-exclamation-triangle"></i> Hata
          </h4>
          <ul class="mb-0">
            <li v-for="e in errors" :key="e.id">
              <b>{{e}}</b> Alanını Doldurmanız gerek
            </li>
          </ul>
        </b-alert>

        <div class="row">
          <div class="col-12 col-md-6 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">Başlık</span>
            </div>
            <input
              type="text"
              class="form-control"
              placeholder="Başlık"
              v-on:change="validate"
              v-on:keyup="createUrl"
              aria-label="Başlık"
              v-bind:class="{'is-invalid' : errors.includes('Başlık')}"
              v-model="post.name"
              id="name"
              aria-describedby="basic-addon1"
            />
          </div>
          <div class="col-12 col-md-6 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="url-label">URL</span>
            </div>
            <input
              type="text"
              class="form-control"
              placeholder="URL"
              aria-label="URL"
              v-on:keyup="slugifyUrl"
              v-on:change="validate"
              v-bind:class="{'is-invalid' : errors.includes('URL')}"
              v-model="post.url"
              id="url"
              aria-describedby="basic-addon1"
            />
          </div>
          <div class="col-12 input-group mb-3 d-flex flex-column align-items-end">
            <!-- <button class="btn btn-primary btn-sm btn-fill" style="margin-bottom: -34px;z-index: 2;" v-b-modal.croppieModal v-on:click="initiateCroppie('tinymce')">Resim Ekle</button> -->
            <tinymce
              id="d1"
              v-model="content.content"
              v-bind:class="{'is-invalid' : errors.includes('İçerik')}"
              style="width: 100%"
              :other_options="options"
            ></tinymce>
          </div>
          <div class="col-12 col-md-11">
            <vue-tabs>
              <v-tab class="card border-top-0" title="Resim">
                <div class="row">
                  <div class="col-12 col-md-6 m-3">
                    <b-btn
                      v-b-modal.croppieModal
                      v-on:click="initiateCroppie('main')"
                      v-bind:class="{'is-invalid' : errors.includes('image')}"
                    >Resim Seç</b-btn>
                    <small class="d-block w-100 mb-3">1200 x 600 pixel</small>

                    <img
                      v-bind:src="image.cropped"
                      class="img-fluid mt-4 d-block border border-secondary p-2"
                      v-bind:class="{'border-danger' : errors.includes('Resim')}"
                    />
                  </div>
                </div>
              </v-tab>
              <v-tab class="card border-top-0" title="Video">
                <div class="row">
                  <div class="col-12 input-group px-5 m-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Video Adresi</span>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="https://www.youtube.com/watch?v=KZzON_7EQ70"
                      aria-label="Başlık"
                      v-model="post.newvideo"
                      id="title"
                      aria-describedby="basic-addon1"
                    />
                  </div>
                </div>
              </v-tab>
            </vue-tabs>
          </div>

          <div class="col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start">
            <button class="btn btn-primary btn-fill" v-on:click="checkForm">Kaydet</button>
          </div>
        </div>
        <b-modal id="croppieModal" hide-footer size="lg" title="Resim Seç">
          <input name="myFile" id="myImage" class="m-3" type="file" @change="bind()" />
          <vue-croppie
            :enable-resize="false"
            :viewport="{width: 480, height: 270, type: 'suare'}"
            :boundary="{width: 640, height: 360}"
            ref="main"
            :enableOrientation="true"
            @result="result"
          ></vue-croppie>
          <b-btn class="mt-3" variant="danger btn-fill" @click="hideCroppieModal()">İptal</b-btn>
          <b-btn class="mt-3" variant="success btn-fill float-right" @click="crop()">Kaydet</b-btn>
        </b-modal>
      </card>
    </div>
  </div>
</template>
<script>
import Card from "src/components/UIComponents/Cards/Card.vue";
import Checkbox from "src/components/UIComponents/Inputs/Checkbox.vue";
export default {
  data: function() {
    return {
      videoupdated: false,
      publishTime: null,
      futurePost: false,
      socialMedia: true,
      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: "LeaderArticles",
        image: null,
        newvideo: null,
        newvideo_id: null,
        content_id: null,
        video_id: null
      },
      categories: null,
      category: {
        category_id: "",
        name: null,
        url: null,
        is_active: 1
      },
      subCategories: null,
      disableParent: false,
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      order: {
        post_id: null,
        slider_group: "LeaderArticles",
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: "title",
            meta_value: null
          },
          meta3: {
            meta_key: "description",
            meta_value: null
          },
          meta4: {
            meta_key: "view_count",
            meta_value: 0
          }
        }
      },
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        cropped: null
      },
      sliderImage: {
        cropped: null
      },
      croppieType: "main",
      sliderImageLoaded: false,
      // end of post data
      users: null,
      options: {
        language_url: "/static/plugins/tinymce-lang/tr.js",
        height: 300
      }
    };
  },
  components: {
    Checkbox,
    Card
  },
  methods: {
    addImageToEditor: function(i) {
      this.$http
        .post("/api/images/upload/" + this.post.url + "_inner-image", {
          cropped: i
        })
        .then(
          response => {
            this.content.content =
              this.content.content +
              '<img src="' +
              this.mediaURL() +
              response.body.Data.Response.name +
              '" width="100%" alt="' +
              this.post.url +
              '" />';
          },
          e => {
            this.notifier("top", "right", "danger", "Bir Hata Oluştu");
            this.toggleLoader();
          }
        );
    },
    checkForm: function() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push("Başlık");
      }
      if (!this.post.url) {
        this.errors.push("URL");
      }
      if (!this.content.content) {
        this.errors.push("İçerik");
      }
      if (!this.image.cropped) {
        this.errors.push("Resim");
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function() {
      this.toggleLoader();
      this.validateUrl()
        .then(resolve => {
          document.getElementById("url").classList.add("is-invalid");
          document.getElementById("url").classList.remove("is-valid");
          document.getElementById("url-label").classList.add("is-invalid");
          document.getElementById("url-label").classList.remove("is-valid");
          this.notifier(
            "top",
            "right",
            "danger",
            "URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin"
          );
          this.toggleLoader();
        })
        .catch(er => {
          var button = event.target;
          // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
          this.saveContent();
        });
    },
    saveContent: function() {
      var button = event.target;
      this.$http.post("/api/contents/add", this.content).then(
        response => {
          this.post.content_id = response.body.Data.Response.id;
          this.saveVideo();
        },
        e => {
          button.innerHTML = "Kaydet";
          this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          this.toggleLoader();
        }
      );
    },
    saveVideo: function() {
      if (this.video.video_url !== null) {
        this.$http.post("/api/videos/add", this.video).then(
          response => {
            this.post.video_id = response.body.Data.Response.name;
            this.saveImage();
          },
          e => {
            this.notifier("top", "right", "danger", "Bir Hata Oluştu");
            this.toggleLoader();
          }
        );
      } else {
        this.saveImage();
      }
    },
    saveImage: function() {
      this.$http.post("/api/images/upload/" + this.post.url, this.image).then(
        response => {
          this.post.image = response.body.Data.Response.name;
          this.savePost();
        },
        e => {
          this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          this.toggleLoader();
        }
      );
    },

    savePost: function() {
      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(
          this.content.content,
          { allowedTags: ["br"] }
        ).substring(0, 500);
      }
      if (this.videoupdated) {
        this.post.video = this.video;
      } else {
        this.post.video = null;
      }
      if(this.post.newvideo){
      var newvideo_id = this.post.newvideo.split("v=")[1];
      var ampersandPosition = newvideo_id.indexOf("&");
      if (ampersandPosition != -1) {
        newvideo_id = newvideo_id.substring(0, ampersandPosition);
      }
      this.post.newvideo_id = newvideo_id;
      }
      this.$http.post("/api/posts/add", this.post).then(
        response => {
          var pid = response.body.Data.Response.id;
          this.post.id = pid;
          this.metas.post_id = pid;
          this.order.post_id = pid;
          this.saveOrder();
        },
        e => {
                         this.toggleLoader();

              if(!e.body.Error){
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            }else{

              this.notifier('top', 'right', 'danger', e.body.Error)

            }
        }
      );
    },
    saveOrder: function() {
      if(this.allposts && this.allposts.length){
        this.order.order_number = this.allposts.length
      }else{
        this.order.order_number = 0
      }
      this.$http.post("/api/slider/add/LeaderArticles", this.order).then(
        response => {
          this.saveMetas();
          this.notifier("top", "right", "success", "Başarılı");
        },
        e => {
          this.toggleLoader();
          this.notifier("top", "right", "danger", "Bir Hata Oluştu");
        }
      );
    },
    saveMetas: function() {
      this.$http.post("/api/post-metas/add-bulk", this.metas).then(
        response => {
          this.notifier("top", "right", "success", "Başarılı");
          this.$router.push("/leader/articles");
          this.toggleLoader();
        },
        e => {
          this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          this.toggleLoader();
        }
      );
    },
    createUrl: function() {
      this.post.url = this.slugify(this.post.name)+'-la';
    },
    slugifyUrl: function() {
      this.post.url = this.slugify(this.post.url);
    },
    validate: function() {
      this.validateUrl()
        .then(resolve => {
          document.getElementById("url").classList.add("is-invalid");
          document.getElementById("url").classList.remove("is-valid");
          document.getElementById("url-label").classList.add("is-invalid");
          document.getElementById("url-label").classList.remove("is-valid");
        })
        .catch(er => {
          document.getElementById("url").classList.add("is-valid");
          document.getElementById("url").classList.remove("is-invalid");
          document.getElementById("url-label").classList.add("is-valid");
          document.getElementById("url-label").classList.remove("is-invalid");
        });
    },

    validateUrl: function() {
      var request = this;
      return new Promise(function(resolve, reject) {
        request.$http.get("/api/filter/posts/url/" + request.post.url).then(
          response => {
            if (parseInt(response.body.meta.total) > 0) {
              resolve(true);
            } else {
              reject(false);
            }
          },
          response => {
            this.notifier(
              "top",
              "right",
              "danger",
              "Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz."
            );
          }
        );
      });
    },
    initiateCroppie(type) {
      if (this.post.url) {
        this.croppieType = type;
      } else {
        this.notifier(
          "top",
          "right",
          "danger",
          "Resim ekleyebilmek için bir başlık belirlemelisiniz."
        );
      }
    },
    bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function(oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop() {
      var dis = this;
      var wdt = 1200;
      var hgt = 600;
      if (this.croppieType === "tinymce") {
        wdt = 1200;
        hgt = 600;
      }
      return new Promise(resolve => {
        let options = {
          format: "jpeg",
          size: {
            width: wdt,
            height: hgt
          },

          quality: 1
        };
        dis.$refs.main.result(options, output => {
          if (this.croppieType === "main") {
            dis.image.cropped = output;
          } else if (this.croppieType === "slider") {
            dis.sliderImage.cropped = output;
            dis.sliderImageLoaded = true;
          } else if (this.croppieType === "tinymce") {
            this.notifier(
              "top",
              "right",
              "warning",
              "Lütfen resim yükleninceye kadar bekleyin."
            );
            this.addImageToEditor(output);
          }
          this.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "croppieModal");
    },
    result(output) {
      return output;
    }
  },  mounted: function() {
      this.$http.get("/api/posts/get-with-type/LeaderArticles").then(
        response => {
          this.allposts = response.body;
        },
        er => {
          this.notifier(
            "top",
            "right",
            "danger",
            "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz."
          );
          this.toggleLoader();
        }
      );
    }
};
</script>
<style>
.input-group-text.is-valid {
  border-color: #28a745 !important;
}
.input-group-text {
  transition: 300ms;
}
.input-group-text.is-invalid {
  border-color: #dc3545 !important;
  background-color: #dc3545;
  color: #fff;
}
.form-check-label {
  font-size: 16px !important;
  line-height: 15px !important;
  text-transform: capitalize !important;
}
.seo-text {
  background-color: #e9ecef;
  border: 1px solid #ced4da;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PostModules/LeaderArticles/Add.vue